module.exports = __webpack_public_path__ + "img/banner4.41f6ead4.jpg";